const typeOptions = [
	{ key: 1, text: "Menú", value: "menu" },
	{ key: 2, text: "Link", value: "link" },
	{ key: 3, text: "Divider", value: "divider" },
];

export default typeOptions;
